module.exports = __webpack_public_path__ + "img/thridPayBgPink.ca4a4686.jpg";